export default "__VITE_ASSET__Bom7bBFH__"